import FilterList, {
	FilterValues,
	OptionsFilter,
} from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import { Module } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { OptionsTable } from 'projects/access-control/src/app/Domain/Entities/options-table.interface';
import { Component, Input, OnInit } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import filtersResourceTable from '../resources/filtersResourceTable';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import filtersVersionsTable from './filtersVersionTable';
import { MatDialog } from '@angular/material/dialog';
import { ModalNewVersionComponent } from 'projects/access-control/src/app/UI/components/modal-new-version/modal-new-version.component';
import { Versions } from 'projects/access-control/src/app/Domain/Entities/versions.interface';
import {
	deleteVersionsModule,
	getVersionsModule,
} from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.action';
import { Store } from '@ngrx/store';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';

@Component({
	selector: 'app-versions',
	templateUrl: './versions.component.html',
	styleUrls: ['./versions.component.scss'],
})
export class VersionsComponent implements OnInit {
	@Input() moduleSelect: Module = {} as Module;
	@Input() translate: any;
	@Input() isLoading: boolean = true;
	@Input() version: Versions[] = [];
	@Input() pagination!: DataPagination;

	openAlert: boolean = false;
	valueModalDelete: string = '';
	nameModal: string = '';
	elementsDelete: any;
	versionSelected!: Versions;
	optionsTable: OptionsTable[] = [
		{
			value: 'edit',
			icon: 'edit',
		},
		{
			value: 'delete',
			icon: 'delete',
		},
	] as OptionsTable[];
	filterList: FilterList[] = filtersVersionsTable;
	columnsFilter: OptionsFilter[] = [
		{ name: 'version', label: 'Version' },
		{ name: 'date', label: 'Date' },
		{ name: 'features', label: 'Features' },
		{ name: 'bugsResolved', label: 'Bugs resolved' },
	];
	modeColum!: any;
	selected: Versions[] = [];
	selectionType = SelectionType;
	search: string = '';
	page = 1;
	constructor(private dialog: MatDialog, private store: Store) {}

	ngOnInit(): void {
		this.modeColum = ColumnMode.force;
	}
	closeModalAlert(event: any) {
		this.openAlert = false;
		if (event.resp) {
			let ids: IPkSk[] = [];
			if (event.value === 'deleteVersion') {
				ids = [{ pk: this.versionSelected.pk, sk: this.versionSelected.sk }];
			}
			if (event.value === 'bulkDeleteVersions') {
				ids = this.selected.map((item) => ({ pk: item.pk, sk: item.sk }));
			}
			this.store.dispatch(
				deleteVersionsModule({
					ids,
					module: { pk: this.moduleSelect.pk, sk: this.moduleSelect.sk },
				})
			);
		}
		this.versionSelected = {} as Versions;
		this.selected = [];
		this.elementsDelete = '';
	}

	actions({ action, value }: { action: 'edit' | 'delete'; value: Versions }) {
		switch (action) {
			case 'delete':
				this.nameModal = 'modalAlertDeleteElement';
				this.versionSelected = value;
				this.elementsDelete = `${this.translate.deleteVersion} '${value.version} '`;
				this.valueModalDelete = 'deleteVersion';
				this.openAlert = true;
				break;
			case 'edit':
				this.dialog.open(ModalNewVersionComponent, {
					minHeight: '450px',
					width: '500px',
					maxWidth: '100vw',
					maxHeight: '100vh',
					data: {
						module: this.moduleSelect,
						type: 'update',
						version: value,
					},
				});
				break;
		}
	}
	buttonAction(option: string) {
		if (option === 'refresh') {
			console.log(this.pagination);
			this.store.dispatch(
				getVersionsModule({
					ids: { pk: this.moduleSelect.pk, sk: this.moduleSelect.sk },
					page: this.page,
					search: this.search,
				})
			);
		} else {
			this.valueModalDelete = 'bulkDeleteVersions';
			this.elementsDelete = '';
			if (this.selected.length > 0) {
				this.nameModal = 'modalAlertDeleteElement';
				this.elementsDelete = `${this.selected.length} ${
					this.selected.length > 1 ? this.translate.deleteBulkVersion : this.translate.deleteVersion
				}`;
			} else {
				this.nameModal = 'modalAlertDeleteNoSelected';
			}
			this.openAlert = true;
		}
	}

	getFilterValues(filter: FilterValues[]) {
		// this.filterResults = filter;
		// this.rowsFilter = this.filter.transform(this.rows, filter) as Resource[];
	}

	filterSelected(options: OptionsFilter[]) {
		// this.url = this.filterService.createUrl(options);
		// if (this.url.length > 0) {
		// 	this.activeFilter = true;
		// 	this.store.dispatch(
		// 		getResourcesModule({
		// 			url: `${this.moduleSelect.relationships.self}/query${this.url}`,
		// 		})
		// 	);
		// } else {
		// 	this.activeFilter = false;
		// 	this.store.dispatch(getResourcesModule({ url: this.moduleSelect.relationships.self }));
		// }
	}

	openDialogVersion() {
		this.dialog.open(ModalNewVersionComponent, {
			minHeight: '450px',
			width: '500px',
			maxWidth: '100vw',
			maxHeight: '100vh',
			data: {
				module: this.moduleSelect,
				type: 'add',
			},
		});
	}

	emitNavigation(page: number) {
		this.page = page;
		this.store.dispatch(
			getVersionsModule({
				ids: { pk: this.moduleSelect.pk, sk: this.moduleSelect.sk },
				page,
				search: this.search,
			})
		);
	}

	onSelect({ selected }: { selected: Versions[] }) {
		this.selected.splice(0, this.selected.length);
		selected.forEach((element: Versions) => {
			this.selected.push(element);
		});
	}
}
